export default "__VITE_ASSET__Bvkxela1__"